import React from 'react';
import LandingPageHeader from '../components/LandingPageHeader';
import LandingPageStats from '../components/LandingPageStats';
import LandingPageProducts from '../components/LandingPageProducts';
import LandingPageMarketplaces from '../components/LandingPageMarketplaces';
import LandingPageHowItWorks from '../components/LandingPageHowItWorks';
import LandingPagePricing from '../components/LandingPagePricing';
import LandingPageFooter from '../components/LandingPageFooter';

const LandingPage: React.FC = () => {
  return (
    <div className="landing-page bg-[rgb(10,25,47)] text-white">
      <LandingPageHeader />
      
      <div id="como-funciona">
        <LandingPageHowItWorks />
      </div>
      
      <LandingPageStats />
      
      <div id="produtos">
        <LandingPageProducts />
      </div>
      
      <div id="marketplaces">
        <LandingPageMarketplaces />
      </div>
      
      <LandingPagePricing />
      
      <LandingPageFooter />
    </div>
  );
};

export default LandingPage;
